import { ZoneContextManager } from '@opentelemetry/context-zone';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';

export interface InitTelemetryOptions {
  endpoint?: string | undefined;
  serviceName?: string | undefined;
  enabled?: boolean | undefined;
}

let initialised = false;

export function initTelemetry(opts: InitTelemetryOptions = {}): void {
  if (initialised || opts.enabled === false || !opts.endpoint) return;
  initialised = true;
  const resource = resourceFromAttributes({ 'service.name': opts.serviceName ?? 'astroline-widget' });
  const provider = new WebTracerProvider({
    resource,
    spanProcessors: [
      new BatchSpanProcessor(new OTLPTraceExporter({ url: `${opts.endpoint}/v1/traces` })),
    ],
  });
  provider.register({ contextManager: new ZoneContextManager() });
  registerInstrumentations({
    instrumentations: [new FetchInstrumentation(), new DocumentLoadInstrumentation()],
  });
}
